import {ReviewsEntitiesFactory} from '../Entities/factory.js'
import {ReviewsValueObjectsFactory} from '../ValueObjects/factory.js'
import {FromCommentsListResponseToCommentListVOMapper} from './FromCommentsListResponseToCommentListVOMapper.js'
import {FromPostResponseToCommentIdEntityMapper} from './FromPostResponseToCommentIdEntityMapper.js'
import {FromRawCommentResponseToCommentEntityMapper} from './FromRawCommentResponseToCommentEntityMapper'
import {FromCommentAnswersResponseToVOMapper} from './NewsCommentAnswersResponseToVOMapper'

export class ReviewsMappersFactory {
  static fromCommentsListResponseToCommentListVOMapper = () =>
    new FromCommentsListResponseToCommentListVOMapper({
      newsCommentsCollectionValueObjectFactory: ReviewsValueObjectsFactory.newsCommentsCollectionValueObject,
      fromRawCommentResponseToCommentEntityMapper:
        ReviewsMappersFactory.fromRawCommentItemResponseToCommentEntityMapper(),
      fromCommentAnswersResponseToVOMapper: ReviewsMappersFactory.fromCommentAnswersResponseToVOMapper()
    })

  static fromPostResponseToCommentIdEntityMapper = () =>
    new FromPostResponseToCommentIdEntityMapper({
      commentIdEntityFactory: ReviewsEntitiesFactory.commentIdEntity
    })

  static fromRawCommentItemResponseToCommentEntityMapper = () =>
    new FromRawCommentResponseToCommentEntityMapper({commentEntityFactory: ReviewsEntitiesFactory.commentEntity})

  static fromCommentAnswersResponseToVOMapper = () =>
    new FromCommentAnswersResponseToVOMapper({
      fromRawCommentResponseToCommentEntityMapper:
        ReviewsMappersFactory.fromRawCommentItemResponseToCommentEntityMapper()
    })
}
